import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const UniversityHistoryContainer = styled(Box)`
  margin: 48px auto;
  padding: 0px 24px;
  max-width: 1136px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 0px;
    margin: 100px auto;
    gap: 94px;
  }
`;

export const UniversityHistory = styled(Box)`
  display: flex;
  flex-direction: column-reverse;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    gap: 48px;
  }
`;

export const ImageWrapperUniversityHistory = styled(Box)`
  /* clip-path: polygon(65% 0, 100% 51%, 65% 100%, 0 100%, 36% 50%, 0 0); */
  max-width: 555px;
  max-height: 622px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 307px;
    height: 340px;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 394px;
    height: 439px;
  }
`;
